export const KeywordTableTitles = {
    TITLE: 'Keywords selected by you',
    SUBTITLE: 'These are the keywords which would be linked to your Ad',
    TABLE_HEADERS: {
        KEYWORD: 'Keyword',
        SEARCH_VOLUME: 'Search Volume',
        IMPRESSIONS: 'Impressions',
        MINIMUM_BID: 'Minimum Bid',
        MATCH_TYPE: 'Match Type',
        YOUR_BID: 'Your Bid',
    },
};
export const TABLE_COLUMNS_WITH_METRICS = [
    // width is 100% / 7
    {
        title: KeywordTableTitles.TABLE_HEADERS.KEYWORD,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.KEYWORD,
        width: '20%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.SEARCH_VOLUME,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.SEARCH_VOLUME,
        width: '15%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.IMPRESSIONS,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.IMPRESSIONS,
        width: '12%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.MINIMUM_BID,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.MINIMUM_BID,
        width: '12%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.MATCH_TYPE,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.MATCH_TYPE,
        width: '18%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.YOUR_BID,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.YOUR_BID,
        width: '18%',
    },
    {
        title: '',
        sortable: false,
        key: 'actions',
        width: '5%',
    },
];
export const TABLE_COLUMNS = [
    // width is 100% / 6
    {
        title: KeywordTableTitles.TABLE_HEADERS.KEYWORD,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.KEYWORD,
        width: '19%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.SEARCH_VOLUME,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.SEARCH_VOLUME,
        width: '19%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.MINIMUM_BID,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.MINIMUM_BID,
        width: '19%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.MATCH_TYPE,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.MATCH_TYPE,
        width: '19%',
    },
    {
        title: KeywordTableTitles.TABLE_HEADERS.YOUR_BID,
        sortable: false,
        key: KeywordTableTitles.TABLE_HEADERS.YOUR_BID,
        width: '19%',
    },
    {
        title: '',
        sortable: false,
        key: 'actions',
        width: '5%',
    },
];
